import React from 'react';
import LoginFixed from './LoginFixed';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';

interface LoginFixedWrapperProps {
  isKioskMode?: boolean;
}

/**
 * LoginFixedWrapper
 * 
 * This component wraps the LoginFixed component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const LoginFixedWrapper: React.FC<LoginFixedWrapperProps> = ({ isKioskMode = false }) => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <LoginFixed isKioskMode={isKioskMode} />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default LoginFixedWrapper;